<template>
    <div id="calendar" class="calendar" @mousemove="dragging" @mouseup="dragging" v-if="getPlatforms">
        <div class="calendar__head calendar-head">
            <div v-for="index in count" :key="index" class="calendar-head__row">{{ index }}</div>
        </div>
        <div class="calendar-body__wrapper">
            <div class="calendar__body">
            <div class="calendar__header calendar-header">
                <div class="calendar-header__dates" @mousedown="dragging" @mousemove="dragging" @mouseup="dragging">
                    <template v-for="date in days">
                        <div class="calendar-header__date" 
                            :class="{'calendar-header__date_monday' : date.isMonday, 'calendar-header__date_today' : date.isToday}" 
                            :data-date="date.dmy" 
                            :style="'width: ' + itemWidth + 'px'">
                            <template v-if="date.isMonday || period === 4">
                                <div v-html="date.formattedDate"></div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
            <div class="calendar-content">
                <div v-for="index in count" 
                    class="calendar-content__row" 
                    :data-row="index" 
                    :class="{'calendar-content__row_warning': index > 5}"
                    :key="index">

                        <div @click="dateClickHandler(date, index)" 
                            v-for="date in days" class="calendar-content__date" 
                            :class="{
                                'calendar-content__date_monday' : date.isMonday, 
                                'calendar-content__date_today': date.isToday, 
                                'calendar-content__date_blocked' : bannersInRange.days[index] && bannersInRange.days[index].includes(date.dayString), 
                                'calendar-content__date_warning': index > 5
                            }" 
                            :data-date="date.dmy" 
                            :data-row="index" 
                            :style="'width: ' + itemWidth + 'px'"
                            :key="date.dmy">

                            <template v-if="bannersInRange[index] && bannersInRange[index][date.dayString]">
                                <div @click="pushTask(bannersInRange[index][date.dayString].id)" 
                                    class="calendar-content__banner calendar-banner" 
                                    :key="bannersInRange[index][date.dayString].id" 
                                    :class="{
                                        'calendar-banner_start': bannersInRange[index][date.dayString].bannerStart, 
                                        'calendar-banner_endonly': !bannersInRange[index][date.dayString].bannerStart
                                    }" 
                                    :style="{width: bannersInRange[index][date.dayString].width + 'px'}">

                                        <template v-if="bannersInRange[index][date.dayString].daysCount >= 3 && bannersInRange[index][date.dayString].bannerStart">
                                            <div class="calendar-banner__image">
                                                <img :src="bannersInRange[index][date.dayString].backgroundMobile">
                                            </div>
                                        </template>

                                        <div class="calendar-banner__head">
                                            <div class="calendar-banner__top">
                                                <span class="calendar-banner__badge">{{getVendorName(bannersInRange[index][date.dayString].vendorName) }}</span>
                                                <span class="calendar-banner__tag">#{{ getTagName(bannersInRange[index][date.dayString].tagName) }}</span>
                                            </div>
                                            <div class="calendar-banner__caption">{{ bannersInRange[index][date.dayString].name }}</div>

                                            <div v-if="bannersInRange[index][date.dayString].createdByName" 
                                                class="calendar-banner__created-by">
                                                    {{ bannersInRange[index][date.dayString].createdByName }}
                                            </div>
                                        </div>

                                        <span v-if="(bannersInRange[index][date.dayString].daysCount >= 7 && 
                                            period === 4 || 
                                            bannersInRange[index][date.dayString].daysCount >= 20) || 
                                            (!bannersInRange[index][date.dayString].bannerStart && 
                                            bannersInRange[index][date.dayString].daysCount >= 5 && 
                                            period === 4 || 
                                            !bannersInRange[index][date.dayString].bannerStart && 
                                            bannersInRange[index][date.dayString].daysCount >= 18)" 
                                            class="calendar-banner__views">
                                                <i class="el-icon-document-copy app-btn-copy" 
                                                    @click.stop.prevent="dubleBanner(bannersInRange[index][date.dayString].id)"
                                                ></i>
                                                <img src="@/assets/img/svg/okko-icon.svg">
                                                {{ bannersInRange[index][date.dayString].views }}
                                        </span>
                                </div>
                            </template>
                            <template v-if="!bannersInRange[index] || !bannersInRange[index][date.dayString]">
                                <p class="calendar-content__warning">
                                    Рекомендуемое количество
                                    <br>баннеров: не более
                                    <b>пяти</b>
                                </p>
                            </template>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import { mapActions, mapGetters } from 'vuex'
    export default {
        name: "TasksCalendar",
        props: ["tasks", "platform", "count", "forbiddenDates"],
        data() {
            return {
                renderCalendar: false,
                settings: {
                    period: 4,
                    months: ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"],
                    shortMonths: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"],
                    startDay: null,
                    endDay: null,
                    itemWidth: null,
                    today: null,
                    blockedDays: {},
                },
                isDragging: false,
                dragShift: 0
            }
        },
        computed: {
            ...mapGetters(['getTags', 'getVendors', 'getPlatforms', 'getBanners']),
            itemsCountInWindow: function() {
                return Math.ceil((document.documentElement.clientWidth - 60) / this.itemWidth);
            },
            itemWidth: function() {
                return this.period === 4 ? 42 : 14;
            },
            substractItems: function() {
                return Math.ceil((this.itemsCountInWindow) / 2);
            },
            startDay: function() {
                return moment(this.settings.startDay).subtract(this.substractItems, "days").toDate();
            },
            endDay: function() {
                return moment(this.settings.startDay).add(this.substractItems, "days").toDate();
            },
            days: function() {
                const days = [];
                let startDate = this.startDay;
                let endDate = this.endDay;
                while (startDate < endDate) {
                    const date = {
                        "utc": moment(startDate).utc().format(),
                        "dmy": moment(startDate).format("D.M.YYYY"),
                        "day": startDate.getDay(),
                        "isMonday": startDate.getDay() === 1,
                        "isToday": moment(startDate).format("D.M.YYYY") === moment(this.settings.today).format("D.M.YYYY"),
                        "month": this.settings.months[startDate.getMonth()],
                        "shortMonth": this.settings.shortMonths[startDate.getMonth()],
                        "formattedDate": ("0" + startDate.getDate()).slice(-2)+ "<br>" + this.settings.shortMonths[startDate.getMonth()],
                        "dayString": moment(startDate).format("DMYYYY")
                    }

                    days.push(date);
                    startDate = moment(startDate).add('1', "days").toDate();
                }

                return days;
            },

            bannersInRange: function() {
                const bannersInRange = {
                    "days": {},
                    "formatDays": {}
                };
                for (let item of this.tasks) {
                    const daysObject = this.isInRange(item);
                    if (daysObject && this.isInFilter(item)) {
                        let bannerStartPeriod = daysObject.startDate || this.startDay;
                        let bannerEndPeriod = daysObject.endDate || this.endDay;
                        let bannerStart = daysObject.startDate ? new Date(item.dateSpace[0]) : false;
                        let bannerEnd = daysObject.endDate ? new Date(item.dateSpace[1]) : false;

                        if (bannerEnd > this.endDay) {
                            bannerEnd = moment(this.endDay).subtract('1', 'days').toDate();
                        }
                         if (bannerEndPeriod > this.endDay) {
                            bannerEndPeriod = moment(this.endDay).subtract('1', 'days').toDate();
                        }

                        const daysCount = Math.abs(moment(bannerStartPeriod).diff(moment(bannerEndPeriod), "days")) + 1;

                        let dateToInsert = bannerStart || bannerEnd;
                        dateToInsert = moment(dateToInsert).format("DMYYYY");
                        const days = [];
                        const formatDays = [];
                        let daysIterator = bannerStartPeriod;
                        while (daysIterator <= bannerEndPeriod) {

                            days.push(moment(daysIterator).format("DMYYYY"));
                            formatDays.push(moment(daysIterator).format("D.M.YYYY"));
                            daysIterator = moment(daysIterator).add('1', 'days').toDate();
                        }

                        if (!bannersInRange[item.inputPosition]) bannersInRange[item.inputPosition] = {};

                        this.blockedDays = dateToInsert;

                        bannersInRange[item.inputPosition][dateToInsert] = {
                            bannerStartPeriod: bannerStartPeriod,
                            bannerEndPeriod: bannerEndPeriod,
                            bannerStart: bannerStart,
                            bannerEnd: bannerEnd,
                            daysCount: daysCount,
                            dateToInsert: dateToInsert,
                            id: item.id,
                            name: item.inputTitleFirst,
                            tagName: item.tagName,
                            vendorName: item.vendorName,
                            visible: item.visibleGroups,
                            background: item.backgroundSrc,
                            backgroundMobile: item.backgroundSrcMobile,
                            width: daysCount * this.itemWidth,
                            createdByName: item.createdByName,
                            views: item.inputCountView
                        };

                        if (!bannersInRange.days[item.inputPosition]) bannersInRange.days[item.inputPosition] = [];
                        if (!bannersInRange.formatDays[item.inputPosition]) bannersInRange.formatDays[item.inputPosition] = [];

                        bannersInRange.days[item.inputPosition] = bannersInRange.days[item.inputPosition].concat(days);
                        bannersInRange.formatDays[item.inputPosition] = bannersInRange.formatDays[item.inputPosition].concat(formatDays);

                    }
                }

                return bannersInRange;
            },

            forbiddenDays: function() {
                const days = {};
                for (let item of this.tasks) {
                    const daysObject = this.isInRange(item);
                    if (daysObject) {
                        let bannerStart = new Date(item.dateSpace[0]);
                        let bannerEnd = new Date(item.dateSpace[1]);
                        if (!days[item.inputPosition]) days[item.inputPosition] = {};
                        if (!days[item.inputPosition][item.visible]) days[item.inputPosition][item.visible] = [];
                        while (bannerStart <= bannerEnd) {
                            days[item.inputPosition][item.visible].push(moment(bannerStart).format("YYYY-MM-DD"));
                            bannerStart = moment(bannerStart).add('1', 'days').toDate();
                        }

                    }
                }

                return days;
            },

            filter: function() {
                return this.$store.state.filters.filter;
            },

            period: function() {
                return parseInt(this.filter.period.id);
            }
        },
        methods: {
            ...mapActions(['fetchTasks']),
            fetchItems: function() {
                const tasks = this.tasks;
                const computedTasks = {};
                for (let task of tasks) {
                    let newTask = {};
                    newTask[task.id] = {
                        id: task.id,
                        rowId: task.inputPosition.toString(),
                        label: task.name,
                        time: {
                            start: new Date().getTime(),
                            end: new Date().getTime() + 365 * 24 * 60 * 60 * 1000
                        }
                    }
                    Object.assign(computedTasks, newTask);
                }
                this.renderCalendar = true;
            },
            isInRange: function(item) {
                const datesObject = {};
                if (new Date(item.dateSpace[0]) >= this.startDay && new Date(item.dateSpace[0]) <= this.endDay) {
                    datesObject.startDate = new Date(item.dateSpace[0]);
                }
                if (new Date(item.dateSpace[1]) <= this.endDay && new Date(item.dateSpace[1]) >= this.startDay) {
                    datesObject.endDate = new Date(item.dateSpace[1]);
                }

                if (new Date(item.dateSpace[1]) >= this.startDay && new Date(item.dateSpace[1]) >= this.endDay && new Date(item.dateSpace[0]) <= this.startDay && new Date(item.dateSpace[0]) <= this.endDay) {
                    datesObject.endDate = new Date(item.dateSpace[1]);
                }

                if (Object.keys(datesObject).length) {
                    return datesObject;
                } else {
                    return false;
                }
            },

            isInFilter: function(item) {
                const filter = this.filter;
                return (item.tagName === parseInt(filter.tag.id) || parseInt(filter.tag.id) === 0) && (item.vendorName === parseInt(filter.vendor.id) || parseInt(filter.vendor.id) === 0 ) && parseInt(item.visible) === parseInt(filter.userGroup.id);
            },

            pushTask(id) {
                this.$parent.pushTask(id, this.forbiddenDays);
            },
            addItem(date, inputPosition) {
                this.$parent.newModal(date, inputPosition, this.forbiddenDays);
            },
            dateClickHandler(date, index) {
                if (this.bannersInRange.days[index] && this.bannersInRange.days[index].includes(date.dayString)) {
                   return false;
                } else {
                    this.addItem(date, index, this.forbiddenDays);
                }
            },
            dragging(event) {
                if (event.type === "mousedown") {
                    this.isDragging = true;
                    this.dragShift = event.clientX;
                }

                if (event.type === "mouseup") {
                    this.isDragging = false;
                }

                if (event.type === "mousemove" && this.isDragging) {
                    const shift = Math.abs(this.dragShift - event.clientX);
                    if (shift >= this.itemWidth) {
                        if (event.clientX <= this.dragShift) {
                            if (this.period === 4)
                                this.settings.startDay = moment(this.settings.startDay).add('1', 'days').toDate();
                            else {
                                this.settings.startDay = moment(this.settings.startDay).add('3', 'days').toDate();
                            }
                        } else {
                            if (this.period === 4)
                                this.settings.startDay = moment(this.settings.startDay).subtract('1', 'days').toDate();
                            else
                                this.settings.startDay = moment(this.settings.startDay).subtract('3', 'days').toDate();
                        }
                        this.dragShift = event.clientX;
                    }
                }
            },
            getTagName(id) {
                for (const tag of this.getTags) {
                    if (tag.id === parseInt(id)) {
                        return tag.tagName;
                    }
                }
            },
            getVendorName(id) {
                for (const vendor of this.getVendors) {
                    if (vendor.id === parseInt(id)) {
                        return vendor.vendorName;
                    }
                }
            },
            async dubleBanner(banner_id) {
                this.$parent.pushTask(banner_id, this.forbiddenDays, false);
                this.$emit('duble', this.forbiddenDays,);
            }
        },
        created() {
            const today = new Date();
            today.setHours(0,0,0,0);
            this.settings.today = today;
            this.settings.startDay = today;
            this.settings.period = parseInt(this.filter.period.id);
        },
        mounted() {
            const self = this;
            document.addEventListener('mouseup', function(event) {
                self.isDragging = false;
            });

            document.addEventListener('mousemove', function(event) {
                if (event.type === "mousemove" && self.isDragging) {
                    const shift = Math.abs(self.dragShift - event.clientX);
                    if (shift >= self.itemWidth) {
                        if (event.clientX <= self.dragShift) {
                            if (self.period === 4)
                                self.settings.startDay = moment(self.settings.startDay).add('1', 'days').toDate();
                            else {
                                self.settings.startDay = moment(self.settings.startDay).add('3', 'days').toDate();
                            }
                        } else {
                            if (self.period === 4)
                                self.settings.startDay = moment(self.settings.startDay).subtract('1', 'days').toDate();
                            else
                                self.settings.startDay = moment(self.settings.startDay).subtract('3', 'days').toDate();
                        }
                        self.dragShift = event.clientX;
                    }
                }
            });
        }
    }

</script>

<style>
    .app-btn-copy {
        font-size: 15px;
        margin-right: 12px;
        cursor: pointer;
    }
    .calendar {
        margin: 0 -30px;
        background-color: #F1F7FC;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
    }

    .calendar-head {
        position: relative;
        padding-top: 60px;
        width: 61px;
        border-right: 1px solid #034580;
        flex-shrink: 0;
    }

    .calendar-head__row {
        padding: 19px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 142px;
        text-align: center;
        vertical-align: middle;
        font-size: 18px;
        color: #56565A;
    }

    .calendar-header {
        height: 60px;
        cursor: move;
        position: sticky;
        top: 0;
        background-color: #f1f7fc;
        z-index: 2;
    }

    .calendar-header__date {
        user-select: none;
        font-size: 12px;
        color: #000000;
    }

    .calendar-header__date_monday {
        font-weight: 900;
        font-size: 14px;
    }

    .calendar-header__date_today {
        color: #034580;
    }

    .calendar-content__row {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        height: 142px;
    }

    .calendar-content__row:hover {
        background-color: #E3EDF4;
    }

    .calendar-content__row_warning:hover {
        background-color: #FDF5F5;
    }

    .calendar-body__wrapper {
        width: 100%;
    }

    .calendar__body {
        position: relative;
    }

    .calendar-header__dates,
    .calendar-header__date {
        height: 100%;
    }

    .calendar-header__dates {
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
    }

    .calendar-header__date {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        text-align: center;

    }


    .calendar-content__date {
        position: relative;
        flex-shrink: 0;
        padding: 19px 0;
        height: 100%;
        background-image: url("../assets/img/svg/dates-background2.svg");
        cursor: pointer;
    }

    .calendar-content__date:not(.calendar-content__date_blocked)::after {
        position: absolute;
        display: none;
        justify-content: center;
        align-items: center;
        content: "+";
        color: #3283CC;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        font-size: 25px;
        border: 1px solid #3283CC;
        border-radius: 3px;
        background: #F4FAFF;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.09);
    }

    .calendar-content__date:not(.calendar-content__date_blocked):hover::after {
        display: flex;
    }

    .calendar-content__date_monday {
        border-left: 1px solid #DCE2E6;
    }

    .calendar-banner_start,
    .calendar-banner_endonly {
        z-index: 1;
        position: absolute;
        left: 0;
        top: 19px;
        display: flex;
        justify-content: flex-start;
        align-items: stretch;
        background: #FFFFFF;
        border: 1px solid #C9C9C9;
        box-sizing: border-box;
        border-radius: 3px;
        height: calc(100% - 38px);
        overflow: hidden;
    }


    .calendar-banner_start:hover,
    .calendar-banner_endonly:hover {
        border-color: #1563AA;
        box-shadow: 0px 4px 15px rgba(3, 69, 128, 0.2);
    }

    .calendar-banner_endonly {
        padding-left: 15px;
        left: auto;
        right: 0;
        border-left: 0;
        border-radius: 0 3px 3px 0;
    }

    .calendar-banner__image {
        margin-right: 10px;
        flex-shrink: 0;
        width: 98px;
        height: 100%;
    }

    .calendar-banner__image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }

    .calendar-banner__top {
        height: 36px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .calendar-banner__badge {
        margin-right: 7px;
        padding: 2px 7px;
        font-size: 10px;
        line-height: 13px;
        color: #fff;
        background: #FF8686;
        border-radius: 10px;
    }

    .calendar-banner__tag {
        font-size: 12px;
        line-height: 15px;
        color: #000000;
    }

    .calendar-banner__caption {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 19px;
        color: #000000;
    }

    .calendar-banner__head {
        width: 400px;
        flex-shrink: 0;
    }

    .calendar-banner_start::after,
    .calendar-banner_endonly::after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        display: block;
        width: 10%;
        height: 100%;
        background: linear-gradient(270deg, #FFFFFF 60.7%, rgba(255, 255, 255, 0) 100%);
    }


    .calendar-content__warning {
        position: absolute;
        left: calc(100% + 15px);
        top: 50%;
        font-size: 15px;
        color: #FF3636;
        white-space: nowrap;
        transform: translateY(-50%);
        display: none;
        z-index: 1;
    }

    .calendar-content__date_warning:not(.calendar-content__date_blocked)::after {
        border-color: #FF3636;
        color: #FF3636;
    }

    .calendar-content__date_warning:not(.calendar-content__date_blocked):hover .calendar-content__warning {
        display: block;
    }

    html {
        overflow-x: hidden;
    }

    .calendar-banner__created-by {
        font-size: 12px;
        line-height: 15px;
        color: #000000;
        margin-top: 5px;
    }

    .calendar-banner__views {
        position: absolute;
        right: 15px;
        top: 9px;
        z-index: 1;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 12px;
        color: #034580;
    }

    .calendar-banner__views img {
        margin-right: 4px;
    }

    .calendar-banner__visible {
        margin-left: 8px;
        padding: 0 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 17px;
        background: #F2F9FC;
        border-radius: 10px;
        font-size: 12px;
        color: #56565A;

    }


</style>